module.exports = __webpack_public_path__ + "img/icon-input-file.a93b5455.svg";